define('viewmodels/pages/cash/PaymentMethodTypeInMaintenanceViewModel',[
   'knockout'
], function (ko) {

    function PaymentMethodTypeInMaintenanceViewModel(wpPageFieldFetcher) {
        var self = this,
            CONTENT_FIELD_MESSAGE = 'message';

        self.content = {
            message: wpPageFieldFetcher(CONTENT_FIELD_MESSAGE)
        };

    };

    return PaymentMethodTypeInMaintenanceViewModel;
});

